export default {
  ACTIVE: '_ACTIVE',
  ACTIVE_BUSINESSES: '_ACTIVE_BUSINESSES',
  ACTIVITY_CREATE_SUCCESS: '_ACTIVITY_CREATE_SUCCESS',
  ADD: '_ADD',
  ADD_ACTIVITY: '_ADD_ACTIVITY',
  ADD_USER: '_ADD_USER',
  AGREE: '_AGREE',
  AGENT_DOCS_FETCH_ERROR: '_AGENT_DOCS_FETCH_ERROR',
  AGENT_DOCS_GENERATE_ERROR: '_AGENT_DOCS_GENERATE_ERROR',
  AGENT_DOCS_NO_DOCUMENTS: '_AGENT_DOCS_NO_DOCUMENTS',
  AGENT_DOCS_NO_LINKS: '_AGENT_DOCS_NO_LINKS',
  AGENT_DOCS_SELECT_ALL_FILTERS: '_AGENT_DOCS_SELECT_ALL_FILTERS',
  AGENT_DOCS_TITLE: '_AGENT_DOCS_TITLE',
  ALL_DAY: '_ALL_DAY',
  ALL_FILTERS: '_ALL_FILTERS',
  ALL_SUBORDINATES: '_ALL_SUBORDINATES',
  APP: '_APP',
  APPLY_FILTERS: '_APPLY_FILTERS',
  ASK_ME_ANYTHING: '_ASK_ME_ANYTHING',
  ASSIGNEES: '_ASSIGNEES',
  AUDIT_HISTORY: '_AUDIT_HISTORY',
  AUTO_SAVED_AT: '_AUTO_SAVED_AT',
  BACK: '_BACK',
  BROCHURES_VIDEOS: '_BROCHURES_VIDEOS',
  BUILD_IN_PROGRESS: '_BUILD_IN_PROGRESS',
  BUILD_IS_DONE: '_BUILD_IS_DONE',
  BUILD_IS_FAILED: '_BUILD_IS_FAILED',
  BUTTON_CANCEL: '_BUTTON_CANCEL',
  BUTTON_SAVE_AND_CONTINUE: '_BUTTON_SAVE_AND_CONTINUE',
  CACHE_CLEAN: '_CACHE_CLEAN',
  CANCEL: '_CANCEL',
  CHANGE_MANAGER: '_CHANGE_MANAGER',
  CHECKLIST: '_CHECKLIST',
  CHECK_FOR_APPROVAL: '_CHECK_FOR_APPROVAL',
  CLEAN_CACHE: '_CLEAN_CACHE',
  CLOSE_COPILOT: '_CLOSE_COPILOT',
  CODE: '_CODE',
  CODE_COVERAGE: '_CODE_COVERAGE',
  COMING_SOON: '_COMING_SOON',
  COMMIT_DONE_AT: '_COMMIT_DONE_AT',
  COMPLETED_APPLICATIONS: '_COMPLETED_APPLICATIONS',
  COMPONENT: '_COMPONENT',
  COMPONENT_NOT_FOUND: '_COMPONENT_NOT_FOUND',
  CONDITION_EQUALS_EXAMPLE: '_CONDITION_EQUALS_EXAMPLE',
  CONFIG_APPLIED_SUCCESSFULLY: '_CONFIG_APPLIED_SUCCESSFULLY',
  CONFIG_SHOULD_BE_AN_OBJECT: '_CONFIG_SHOULD_BE_AN_OBJECT',
  CONFIRMATION_PROCEED_ACTION: '_CONFIRMATION_PROCEED_ACTION',
  CONFIRM_ACTION_PROMPT: '_CONFIRM_ACTION_PROMPT',
  CONFIRM_CREATE_PATCH_BRANCH: '_CONFIRM_CREATE_PATCH_BRANCH',
  CONFIRM_CREATE_RELEASE_BRANCH: '_CONFIRM_CREATE_RELEASE_BRANCH',
  CONFIRM_MPIN: '_CONFIRM_MPIN',
  CONFIRM_PASSWORD: '_CONFIRM_PASSWORD',
  CONFIRM_SELECTION: '_CONFIRM_SELECTION',
  CONTACT_US: '_CONTACT_US',
  COVERAGE: '_COVERAGE',
  CREATE_FORM: '_CREATE_FORM',
  CREATE_TASK: '_CREATE_TASK',
  CREATE_NEW_APPLICATION: '_CREATE_NEW_APPLICATION',
  CRON_DETAILS: '_CRON_DETAILS',
  CURRENT: '_CURRENT',
  CYPRESS_DASHBOARD: '_CYPRESS_DASHBOARD',
  CYPRESS_DASHBOARD_OPENED_IN_ANOTHER_TAB:
    '_CYPRESS_DASHBOARD_OPENED_IN_ANOTHER_TAB',
  CYPRESS_DELETE: '_CYPRESS_DELETE',
  DATA_SYNC_CHECK_BACK_LATER: '_DATA_SYNC_CHECK_BACK_LATER',
  DATA_SYNC_IN_PROGRESS: '_DATA_SYNC_IN_PROGRESS',
  DATA_SYNC_PROCESS_INITIATED: '_DATA_SYNC_PROCESS_INITIATED',
  DEFAULT: '_DEFAULT',
  DELETE_CYPRESS_RUNS: '_DELETE_CYPRESS_RUNS',
  DELETE_PROJECT: '_DELETE_PROJECT',
  DESKTOP: '_DESKTOP',
  DETAILS: '_DETAILS',
  DISABLE_USER: '_DISABLE_USER',
  DISCARD: '_DISCARD',
  DISCONNECTED_PLEASE_TRY_AGAIN: '_DISCONNECTED_PLEASE_TRY_AGAIN',
  DOCUMENT_PREVIEW: '_DOCUMENT_PREVIEW',
  DONE: '_DONE',
  DOWNLOAD: '_DOWNLOAD',
  DOWNLOAD_TEMPLATE: '_DOWNLOAD_TEMPLATE',
  DYNAMIC: '_DYNAMIC',
  E2E_INTEGRATION: '_E2E_INTEGRATION',
  EDIT: '_EDIT',
  EDIT_EXISTING_UI: '_EDIT_EXISTING_UI',
  EDIT_FORM: '_EDIT_FORM',
  EDIT_TASK: '_EDIT_TASK',
  EDIT_USER: '_EDIT_USER',
  EMAIL: '_EMAIL',
  ENABLE_USER: '_ENABLE_USER',
  ENTER_PHONE_NUMBER: '_ENTER_PHONE_NUMBER',
  ENTER_EMAIL: '_ENTER_EMAIL',
  ENTER_FEATURE_TILE_DESCRIPTION: '_ENTER_FEATURE_TILE_DESCRIPTION',
  ENTER_FEATURE_TILE_ICON: '_ENTER_FEATURE_TILE_ICON',
  ENTER_FEATURE_TILE_NAME: '_ENTER_FEATURE_TILE_NAME',
  ENTER_JIRA_TICKET_ID: '_ENTER_JIRA_TICKET_ID',
  ENTER_NUMBER: '_ENTER_NUMBER',
  ENTER_PASSWORD: '_ENTER_PASSWORD',
  ENTER_PROJECT_NAME: '_ENTER_PROJECT_NAME',
  ENTER_SAVE_QUERY: '_ENTER_SAVE_QUERY',
  ENTER_SELFSERVE_CONFIG: '_ENTER_SELFSERVE_CONFIG',
  ENTER_TEXT: '_ENTER_TEXT',
  ENTER_UI_QUERY: '_ENTER_UI_QUERY',
  ENTITIES: '_ENTITIES',
  ENTITY_LIST: '_ENTITY_LIST',
  ENTITY_DETAILS_NOT_FOUND: '_ENTITY_DETAILS_NOT_FOUND',
  ERROR_ARGUMENT_EMPTY_AT_TYPE: '_ERROR_ARGUMENT_EMPTY_AT_TYPE',
  ERROR_FETCHING_CARD_DATA: '_ERROR_FETCHING_CARD_DATA',
  ERROR_FETCHING_CARD_DETAILS: '_ERROR_FETCHING_CARD_DETAILS',
  ERROR_FETCHING_CONFIG_DATA: '_ERROR_FETCHING_CONFIG_DATA',
  ERROR_FETCHING_DETAILS_DATA: '_ERROR_FETCHING_DETAILS_DATA',
  ERROR_FETCHING_FEATURE_CONFIG_DATA: '_ERROR_FETCHING_FEATURE_CONFIG_DATA',
  ERROR_FETCHING_GROUP_DATA: '_ERROR_FETCHING_GROUP_DATA',
  ERROR_FETCHING_HEADER_DATA: '_ERROR_FETCHING_HEADER_DATA',
  ERROR_FETCHING_HEADER_DETAILS: '_ERROR_FETCHING_HEADER_DETAILS',
  ERROR_FETCHING_LIST_DATA: '_ERROR_FETCHING_LIST_DATA',
  ERROR_FETCHING_PROFILE_DATA: '_ERROR_FETCHING_PROFILE_DATA',
  ERROR_FETCH_GUEST_TOKEN_FAILED: '_ERROR_FETCH_GUEST_TOKEN_FAILED',
  ERROR_FIELDS_PROPERTY_INVALID: '_ERROR_FIELDS_PROPERTY_INVALID',
  ERROR_FUNCTION_ARGUMENTS_EXPECTED: '_ERROR_FUNCTION_ARGUMENTS_EXPECTED',
  ERROR_FUNCTION_INVALID: '_ERROR_FUNCTION_INVALID',
  ERROR_GUEST_TOKEN_FETCH_FAILED: '_ERROR_GUEST_TOKEN_FETCH_FAILED',
  ERROR_INVALID_QUERY_NEAR_ID: '_ERROR_INVALID_QUERY_NEAR_ID',
  ERROR_INVALID_QUERY_LENGTH_NEAR_PARAM:
    '_ERROR_INVALID_QUERY_LENGTH_NEAR_PARAM',
  ERROR_LOGOUT_FAILED: '_ERROR_LOGOUT_FAILED',
  ERROR_SESSION_EXPIRED_LOGGED_OUT: '_ERROR_SESSION_EXPIRED_LOGGED_OUT',
  ERROR_SUBMITTING_FORM: '_ERROR_SUBMITTING_FORM',
  EXPLORE_OTHER_BUSINESSES_PROMPT: '_EXPLORE_OTHER_BUSINESSES_PROMPT',
  EXTRA_CHARACTERS_FOUND: '_EXTRA_CHARACTERS_FOUND',
  FAILED_TO_CLEAR_HISTORY_TRY_AGAIN: '_FAILED_TO_CLEAR_HISTORY_TRY_AGAIN',
  FAILED_TO_CONNECT_PLEASE_TRY_AGAIN: '_FAILED_TO_CONNECT_PLEASE_TRY_AGAIN',
  FAILED_TO_FETCH_HISTORY: '_FAILED_TO_FETCH_HISTORY',
  FAILED_TO_GENERATE_RESPONSE: '_FAILED_TO_GENERATE_RESPONSE',
  FEATURES: '_FEATURES',
  FEATURE_BRANCH: '_FEATURE_BRANCH',
  FEATURE_CONFIGURATION_DESCRIPTION: '_FEATURE_CONFIGURATION_DESCRIPTION',
  FILTERS: '_FILTERS',
  FORM_BUILDER: '_FORM_BUILDER',
  FORM_CONFIG_DESCRIPTION: '_FORM_CONFIG_DESCRIPTION',
  FORMULA_FRAMEWORK: '_FORMULA_FRAMEWORK',
  FRONTEND_EVOLVED: '_FRONTEND_EVOLVED',
  FRONTEND_WIKI: '_FRONTEND_WIKI',
  FIRST_CONVERSATION_PROMPTS: '_FIRST_CONVERSATION_PROMPTS',
  GENERIC_ERROR_MESSAGE: '_GENERIC_ERROR_MESSAGE',
  GENERIC_ERROR_TRY_AGAIN: '_GENERIC_ERROR_TRY_AGAIN',
  HELP_IF_UNKNOWN_NPN: '_HELP_IF_UNKNOWN_NPN',
  HISTORY: '_HISTORY',
  HOME: '_HOME',
  HORIZONTAL_LINE: '_HORIZONTAL_LINE',
  INCOMING_EMAIL: '_INCOMING_EMAIL',
  IN_PROGRESS: '_IN_PROGRESS',
  INVALID_EMAIL: '_INVALID_EMAIL',
  INVALID_JSON: '_INVALID_JSON',
  KT: '_KT',
  KT_OPENED_IN_ANOTHER_TAB: '_KT_OPENED_IN_ANOTHER_TAB',
  LABEL_DATA_RETENTION_DAYS: '_LABEL_DATA_RETENTION_DAYS',
  LAST_ENGAGEMENT: '_LAST_ENGAGEMENT',
  LAUNCH_APP: '_LAUNCH_APP',
  LEADS: '_LEADS',
  LEAVE: '_LEAVE',
  LINEWORKS: '_LINEWORKS',
  LOADING_CONFIG_EDITOR: '_LOADING_CONFIG_EDITOR',
  LOCATION: '_LOCATION',
  LOG_ACTIVITY: '_LOG_ACTIVITY',
  LOGIN_WITH_PROVIDER: '_LOGIN_WITH_PROVIDER',
  LOGIN_WITH_OTHER_OPTIONS: '_LOGIN_WITH_OTHER_OPTIONS',
  LOGOUT: '_LOGOUT',
  MANAGERS: '_MANAGERS',
  MANAGER_CHANGE_SUCCESS: '_MANAGER_CHANGE_SUCCESS',
  MANAGER_DATA_VISIBILITY_DELAY_NOTE: '_MANAGER_DATA_VISIBILITY_DELAY_NOTE',
  MAX_SIZE_LIMIT_INFO: '_MAX_SIZE_LIMIT_INFO',
  MENU: '_MENU',
  MESSAGE_SIGNING_SUCCESS_PROCEED: '_MESSAGE_SIGNING_SUCCESS_PROCEED',
  METRICS: '_METRICS',
  TRACKING: '_TRACKING',
  MOBILE: '_MOBILE',
  MODULE_INTEGRATION: '_MODULE_INTEGRATION',
  MORE: '_MORE',
  MPIN_MISMATCH_ERROR: '_MPIN_MISMATCH_ERROR',
  MPIN_DIGITS: '_MPIN_DIGITS',
  MY_DIRECT_REPORTS: '_MY_DIRECT_REPORTS',
  MY_PEERS: '_MY_PEERS',
  MY_MANAGER: '_MY_MANAGER',
  NAVIGATE: '_NAVIGATE',
  NEW_PROJECT: '_NEW_PROJECT',
  NEW_RELEASE: '_NEW_RELEASE',
  NO: '_NO',
  NOT_SAVED: '_NOT_SAVED',
  NO_ACTIVITIES_FOUND: '_NO_ACTIVITIES_FOUND',
  NO_DATA_FOUND_FOR_CARD: '_NO_DATA_FOUND_FOR_CARD',
  NO_FIELDS_TO_DISPLAY_CAPITAL: '_NO_FIELDS_TO_DISPLAY_CAPITAL',
  NO_HISTORY_FOUND: '_NO_HISTORY_FOUND',
  NO_INPUTS_FOUND: '_NO_INPUTS_FOUND',
  NO_PROFILE_DATA_FOUND: '_NO_PROFILE_DATA_FOUND',
  NO_PROFILE_FIELDS_FOUND: '_NO_PROFILE_FIELDS_FOUND',
  NO_PROJECTS: '_NO_PROJECTS',
  NO_REFERRED_ENTITIES_FOUND: '_NO_REFERRED_ENTITIES_FOUND',
  NPM_REGISTRY: '_NPM_REGISTRY',
  NPN_LOOKUP_TOOL: '_NPN_LOOKUP_TOOL',
  ONBOARDING_IN_PROGRESS_COUNT: '_ONBOARDING_IN_PROGRESS_COUNT',
  OTP_DIGITS: '_OTP_DIGITS',
  OUTGOING_EMAIL: '_OUTGOING_EMAIL',
  OUTLOOK_CALENDAR: '_OUTLOOK_CALENDAR',
  PARTICIPANTS: '_PARTICIPANTS',
  PASSWORD: '_PASSWORD',
  PASSWORD_MISMATCH_ERROR: '_PASSWORD_MISMATCH_ERROR',
  PATCH_CURRENT: '_PATCH_CURRENT',
  PENDING_ACTIVITIES: '_PENDING_ACTIVITIES',
  PLACEHOLDER_SELECT_HINT: '_PLACEHOLDER_SELECT_HINT',
  PLAYGROUND: '_PLAYGROUND',
  PORTAL_ID_CLIENT_ID: '_PORTAL_ID_CLIENT_ID',
  PRIMARY_PHONE_NUMBER: '_PRIMARY_PHONE_NUMBER',
  PRINT: '_PRINT',
  PROJECT: '_PROJECT',
  PROJECT_PUBLISH_FILENAME_INFO: '_PROJECT_PUBLISH_FILENAME_INFO',
  PROPERTY_TO_BIND: '_PROPERTY_TO_BIND',
  PROPS_UI_ELEMENT_TYPE: '_PROPS_UI_ELEMENT_TYPE',
  PROVIDE_QUERY_FOR_TYPE_CASES: '_PROVIDE_QUERY_FOR_TYPE_CASES',
  PUBLISH: '_PUBLISH',
  PUBLISH_UI: '_PUBLISH_UI',
  PULL_REQUEST_CREATED: '_PULL_REQUEST_CREATED',
  QUERY: '_QUERY',
  REASSIGN: '_REASSIGN',
  RECENT: '_RECENT',
  RECOMMENDED_FOR_YOU: '_RECOMMENDED_FOR_YOU',
  REFERRAL_SOURCE: '_REFERRAL_SOURCE',
  REFRESH: '_REFRESH',
  RELEASE_BRANCHES: '_RELEASE_BRANCHES',
  RELATED_QUESTIONS: '_RELATED_QUESTIONS',
  RESET: '_RESET',
  RESET_CAPITAL: '_RESET_CAPITAL',
  RESET_PASSWORD_WITH_OTP_NOTE: '_RESET_PASSWORD_WITH_OTP_NOTE',
  RESUME_SESSION: '_RESUME_SESSION',
  RETRY: '_RETRY',
  RUN_PROJECT: '_RUN_PROJECT',
  SAMPLE_CONFIG_CAPITAL: '_SAMPLE_CONFIG_CAPITAL',
  SAMPLE_CONFIGS: '_SAMPLE_CONFIGS',
  SAMPLE_FORM: '_SAMPLE_FORM',
  SAVE: '_SAVE',
  SCHEDULE_ACTIVITY: '_SCHEDULE_ACTIVITY',
  SCHEDULED_ACTIVITIES: '_SCHEDULED_ACTIVITIES',
  SCHEDULE_FOLLOWUP: '_SCHEDULE_FOLLOWUP',
  SELECT: '_SELECT',
  SELECT_ACTIVITY: '_SELECT_ACTIVITY',
  SELECT_ASSIGNEES: '_SELECT_ASSIGNEES',
  SELECT_PARTICIPANTS: '_SELECT_PARTICIPANTS',
  SELECT_THE_APP: '_SELECT_THE_APP',
  SELECT_TYPE: '_SELECT_TYPE',
  SELECT_USER: '_SELECT_USER',
  SELECT_VALUE: '_SELECT_VALUE',
  SELF: '_SELF',
  SELFSERVE: '_SELFSERVE',
  SEND_FOR_APPROVAL: '_SEND_FOR_APPROVAL',
  SESSION_EXPIRED: '_SESSION_EXPIRED',
  SHARE: '_SHARE',
  SHARE_VIA_GMAIL: '_SHARE_VIA_GMAIL',
  SHARE_VIA_LINEWORKS: '_SHARE_VIA_LINEWORKS',
  SHARE_VIA_OUTLOOK: '_SHARE_VIA_OUTLOOK',
  SHARE_VIA_SMS: '_SHARE_VIA_SMS',
  SHARE_VIA_VYMO: '_SHARE_VIA_VYMO',
  SHARE_VIA_WEBEX_MEETING: '_SHARE_VIA_WEBEX_MEETING',
  SHARE_VIA_WHATSAPP: '_SHARE_VIA_WHATSAPP',
  SHOW_LESS: '_SHOW_LESS',
  SHOW_MORE: '_SHOW_MORE',
  START: '_START',
  STATIC: '_STATIC',
  STEPPER_PLAYGROUND: '_STEPPER_PLAYGROUND',
  STEPPER_PLAYGROUND_CAPITAL: '_STEPPER_PLAYGROUND_CAPITAL',
  STEPS: '_STEPS',
  STEP_CAPITAL: '_STEP_CAPITAL',
  STORYBOOK: '_STORYBOOK',
  STORYBOOK_OPENED_IN_ANOTHER_TAB: '_STORYBOOK_OPENED_IN_ANOTHER_TAB',
  SWAGGER_API_DOCS: '_SWAGGER_API_DOCS',
  SUBMIT: '_SUBMIT',
  SUBMIT_CAPITAL: '_SUBMIT_CAPITAL',
  SUPERSET_DATA_NOT_FOUND: '_SUPERSET_DATA_NOT_FOUND',
  SUPPORTED_FORMATS_INFO: '_SUPPORTED_FORMATS_INFO',
  TABLET: '_TABLET',
  TARGET_COVERAGE: '_TARGET_COVERAGE',
  TEAM: '_TEAM',
  TEAM_SELF: '_TEAM_SELF',
  TEMPLATE: '_TEMPLATE',
  TEMPLATE_CONFIG: '_TEMPLATE_CONFIG',
  TEMPLATE_CONFIG_CAPITAL: '_TEMPLATE_CONFIG_CAPITAL',
  TEMPLATE_DRAFT_ALREADY_EXISTS: '_TEMPLATE_DRAFT_ALREADY_EXISTS',
  TEMPLATE_DRAFT_VERSION_EXISTS_ERROR: '_TEMPLATE_DRAFT_VERSION_EXISTS_ERROR',
  TEMPLATE_LINKED: '_TEMPLATE_LINKED',
  TEMPLATE_NOT_PUBLISHED: '_TEMPLATE_NOT_PUBLISHED',
  TOKENIZATION_ERROR: '_TOKENIZATION_ERROR',
  TRANSLATE_SSUI_RULES_TO_FORMULA_CAPITAL:
    '_TRANSLATE_SSUI_RULES_TO_FORMULA_CAPITAL',
  UI_BUILDER: '_UI_BUILDER',
  UNDEPLOYED: '_UNDEPLOYED',
  INVALIDATED: '_INVALIDATED',
  UNIQUE_CODE_UI_FILENAME_INFO: '_UNIQUE_CODE_UI_FILENAME_INFO',
  UNLOCK_USER: '_UNLOCK_USER',
  UNSAVED_CHANGES: '_UNSAVED_CHANGES',
  UPDATE: '_UPDATE',
  UPDATE_CONFIG_CAPITAL: '_UPDATE_CONFIG_CAPITAL',
  UPDATE_FORM: '_UPDATE_FORM',
  UPDATE_TASK: '_UPDATE_TASK',
  UPLOAD_FILE: '_UPLOAD_FILE',
  USE: '_USE',
  USER: '_USER',
  USERS_LIST: '_USERS_LIST',
  USER_360_DATA_NOT_FOUND: '_USER_360_DATA_NOT_FOUND',
  USER_DETAILS: '_USER_DETAILS',
  USER_DISABLE_SUCCESS: '_USER_DISABLE_SUCCESS',
  USER_ENABLE_SUCCESS: '_USER_ENABLE_SUCCESS',
  USER_PROFILE: '_USER_PROFILE',
  USER_PROFILE_GROUPS_NOT_FOUND: '_USER_PROFILE_GROUPS_NOT_FOUND',
  USER_UNLOCK_SUCCESS: '_USER_UNLOCK_SUCCESS',
  USER_UPDATE_SUCCESS: '_USER_UPDATE_SUCCESS',
  VALIDATE: '_VALIDATE',
  VALIDATIONS: '_VALIDATIONS',
  VALIDATION_SELECT_ALL_FIELDS: '_VALIDATION_SELECT_ALL_FIELDS',
  VIA_GMAIL: '_VIA_GMAIL',
  VIA_LINEWORKS: '_VIA_LINEWORKS',
  VIA_OUTLOOK: '_VIA_OUTLOOK',
  VIA_SMS: '_VIA_SMS',
  VIA_VYMO: '_VIA_VYMO',
  VIA_WHATSAPP: '_VIA_WHATSAPP',
  VM_DETAILS: '_VM_DETAILS',
  VM_STORAGE_DETAILS: '_VM_STORAGE_DETAILS',
  VYMO_COPILOT: '_VYMO_COPILOT',
  VYMO_FEATURE_BRANCH: '_VYMO_FEATURE_BRANCH',
  VYMO_FORM: '_VYMO_FORM',
  VYMO_REGISTRY_OPENED_IN_ANOTHER_TAB: '_VYMO_REGISTRY_OPENED_IN_ANOTHER_TAB',
  VYMO_WEB: '_VYMO_WEB',
  VIEW_ALL: '_VIEW_ALL',
  VIEW_LEAD: '_VIEW_LEAD',
  WARNING_DELETE_CYPRESS_OLD_RECORDS: '_WARNING_DELETE_CYPRESS_OLD_RECORDS',
  WARNING_DELETE_YARN_CACHE_DOCKER_VOLUMES:
    '_WARNING_DELETE_YARN_CACHE_DOCKER_VOLUMES',
  WARNING_UNSAVED_CHANGES_CONFIRM_LEAVE:
    '_WARNING_UNSAVED_CHANGES_CONFIRM_LEAVE',
  WEB: '_WEB',
  WEBEX_MEETING: '_WEBEX_MEETING',
  WEB_PLATFORM: '_WEB_PLATFORM',
  WEBPLATFORM_BRANCH: '_WEBPLATFORM_BRANCH',
  WELCOME: '_WELCOME',
  WIKI_OPENED_IN_ANOTHER_TAB: '_WIKI_OPENED_IN_ANOTHER_TAB',
  YES: '_YES',
  ZOOM_MEETING: '_ZOOM_MEETING',
  NO_COMPARISON_REPORT: '_NO_COMPARISON_REPORT',
  APPOINTMENT_LICENSE_NOTE: '_APPOINTMENT_LICENSE_NOTE',
  LAST_MODIFIED: '_LAST_MODIFIED',
  PR: '_PR',
  INVALID_ACTION_REDIRECTION: '_INVALID_ACTION_REDIRECTION',
  SELECT_APP: '_SELECT_APP',
  SELECT_EVENT: '_SELECT_EVENT',
  SELECT_ENV: '_SELECT_ENV',
  SELECT_TIME_RANGE: '_SELECT_TIME_RANGE',
  TRACK_EVENTS: '_TRACK_EVENTS',
  ADDRESS_FIELD_HEADER: '_ADDRESS_FIELD_HEADER',
  ACTIVITIES: '_ACTIVITIES',
  COMPLETED_ACTIVITIES: 'COMPLETED_ACTIVITIES',
  PLANNED_ACTIVITIES: 'PLANNED_ACTIVITIES',
  IMPERSONATE: '_IMPERSONATE',
  NO_ROWS_FOUND: '_NO_ROWS_FOUND',
  GET_HELP: '_GET_HELP',
  SCREEN_RECORDING_STARTED: '_SCREEN_RECORDING_STARTED',
  OFFICE_365: '_OFFICE_365',
  ZOOM: '_ZOOM',
  WEBEX: '_WEBEX',
  GOOGLE: '_GOOGLE',
  CONFIRMATION: '_CONFIRMATION',
  ASK_COPILOT: '_ASK_COPILOT',
  AT: '_AT',
  TODAY_AT: '_TODAY_AT',
  YESTERDAY_AT: '_YESTERDAY_AT',
  WELCOME_TEXT1: '_WELCOME_TEXT1',
  WELCOME_TEXT3_NEW_A: '_WELCOME_TEXT3_NEW_A',
  WELCOME_TEXT3_NEW_B: '_WELCOME_TEXT3_NEW_B',
  HEY_STRING: '_HEY_STRING',
  HEY_TEXT: '_HEY_TEXT',
  HEY: '_HEY',
  CLICK_LINK: '_CLICK_LINK',
  AUTOMATED_ACTIVITIES: '_AUTOMATED_ACTIVITIES',
  DOWNLOAD_LIST: '_DOWNLOAD_LIST',
  ERROR_DOWNLOADING_LIST: '_ERROR_DOWNLOADING_LIST',
  JOB_TYPE: '_JOB_TYPE',
  STATUS: '_STATUS',
  RECEIVED_DATE: '_RECEIVED_DATE',
  AVAILABLE_TILL: '_AVAILABLE_TILL',
  PROGRESS: '_PROGRESS',
  JOB_DETAILS: '_JOB_DETAILS',
  DOWNLOAD_USERS: '_DOWNLOAD_USERS',
  DOWNLOAD_LINK_IN_PROGRESS: '_DOWNLOAD_LINK_IN_PROGRESS',
  DOWNLOAD_READY: '_DOWNLOAD_READY',
  DOWNLOAD_JOB_CANCELLED: '_DOWNLOAD_JOB_CANCELLED',
  COMPLETED: '_COMPLETED',
  RE_REQUEST_DOWNLOAD: '_RE_REQUEST_DOWNLOAD',
  DOWNLOAD_REPORT: '_DOWNLOAD_REPORT',
  CANCEL_DOWNLOAD: '_CANCEL_DOWNLOAD',
  ERROR_DOWNLOADING_FILE: '_ERROR_DOWNLOADING_FILE',
  WORKFLOW_DOWNLOADS: '_WORKFLOW_DOWNLOADS',
  CRM_UPDATE_STATUS: '_CRM_UPDATE_STATUS',
  CALL_INITIATED_MESSAGE: '_CALL_INITIATED_MESSAGE',
  SELECT_PHONE_NUMBER: '_SELECT_PHONE_NUMBER',
  SELECT_LOCATION: '_SELECT_LOCATION',
  ACTIVITY: '_ACTIVITY',
  CREATE: '_CREATE',
  CREATE_ACTIVITY: '_CREATE_ACTIVITY',
  PAYMENT: '_PAYMENT',
  CREATE_PAYMENT: '_CREATE_PAYMENT',
  NAME: '_NAME',
  ACTIVITY_TYPE: '_ACTIVITY_TYPE',
  WORKFLOW_TYPE: '_WORKFLOW_TYPE',
  ERROR_CANCELLING_DOWNLOAD: '_ERROR_CANCELLING_DOWNLOAD',
  CREATE_NEW_RECORD: '_CREATE_NEW_RECORD',
  CREATE_NEW_USER: '_CREATE_NEW_USER',
  RESET_ALL: '_RESET_ALL',
  MANAGE_COLUMNS: '_MANAGE_COLUMNS',
  MANAGE_COLUMNS_DESC: '_MANAGE_COLUMNS_DESC',
  YOU_HAVE: '_YOU_HAVE',
  PENDING_ACTIVITIES_INFO: '_PENDING_ACTIVITIES_INFO',
  NO_NAME: '_NO_NAME',
  NO_ADDRESS_FOUND: '_NO_ADDRESS_FOUND',
  CONFIRM: '_CONFIRM',
  DISCONNECT_CONFIRMATION: '_DISCONNECT_CONFIRMATION',
  NO_MATCH_FOUND: '_NO_MATCH_FOUND',
  TRY_DIFFERENT_KEYWORD: '_TRY_DIFFERENT_KEYWORD',
  SEARCH_PLACEHOLDER: '_SEARCH_PLACEHOLDER',
  ACTIVITY_CARD_PLACEHOLDER: '_ACTIVITY_CARD_PLACEHOLDER',
  ACTIVITY_CARD_LOADING: '_ACTIVITY_CARD_LOADING',
  NO_FILTER_FIELDS_FOUNDS: '_NO_FILTER_FIELDS_FOUNDS',
  SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
  TRAILS: '_TRAILS',
  ADD_A_TRAIL: '_ADD_A_TRAIL',
  AUDIT: '_AUDIT',
  BORROWERS: '_BORROWERS',
  ACTIVITY_ADDED_SUCCESSFULLY: '_ACTIVITY_ADDED_SUCCESSFULLY',
  END_TIME_MUST_BE_GREATER_THAN_START_TIME:
    '_END_TIME_MUST_BE_GREATER_THAN_START_TIME',
  PLAN_YOUR_MEETING_DATE_TIME_BEFORE: '_PLAN_YOUR_MEETING_DATE_TIME_BEFORE',
  VIEW_ON_GOOGLE_MAPS: '_VIEW_ON_GOOGLE_MAPS',
  NO_POLICY_DETAILS_FOUND: '_NO_POLICY_DETAILS_FOUND',
  POLICY_DETAILS: '_POLICY_DETAILS',
  DETAIL: '_DETAIL',
  COLLECT_PAYMENT: '_COLLECT_PAYMENT',
  SIGNIN_INTO_VYMO: '_SIGNIN_INTO_VYMO',
  BACK_TO_LOGIN: '_BACK_TO_LOGIN',
  DELETE: '_DELETE',
  REACTIVATE: '_REACTIVATE',
  SEND_MESSAGE: '_SEND_MESSAGE',
  INITIATE_AI_CALL: '_INITIATE_AI_CALL',
  ENGAGEMENT: '_ENGAGEMENT',
  UI_FIELDS: '_UI_FIELDS',
  ENGAGEMENT_DETAILS: '_ENGAGEMENT_DETAILS',
  ENGAGEMENT_OUTCOME: '_ENGAGEMENT_OUTCOME',
  AMOUNT: '_AMOUNT',
  UPDATED: '_UPDATED',
  OPEN: '_OPEN',
  PAYMENT_PENDING: '_PAYMENT_PENDING',
  PAYMENT_COMPLETED: '_PAYMENT_COMPLETED',
  NO_RESULTS_TO_SHOW: '_NO_RESULTS_TO_SHOW',
  FACING_ERROR: '_FACING_ERROR',
  SERVER_ERROR_MESSAGE: '_SERVER_ERROR_MESSAGE',
  NO_DATA_TO_SHOW: '_NO_DATA_TO_SHOW',
  KEY_METRICS: '_KEY_METRICS',
  MIN_CHARS_TO_SEE_RESULTS: '_MIN_CHARS_TO_SEE_RESULTS',
  RECENT_SEARCHES: '_RECENT_SEARCHES',
  RESULT_WILL_POPULATE_HERE: '_RESULT_WILL_POPULATE_HERE',
  PLEASE_WAIT_WHILE_WE_COMPLETE_YOUR_QUERY:
    '_PLEASE_WAIT_WHILE_WE_COMPLETE_YOUR_QUERY',
  SEARCH_RESULTS: '_SEARCH_RESULTS',
  IN: '_IN',
  PERFORMANCE: '_PERFORMANCE',
  DASHBOARD: '_DASHBOARD',
  NO_MODULE_FOUND: '_NO_MODULE_FOUND',
  LEADERBOARD: '_LEADERBOARD',
  TEAM_BREAKDOWN: '_TEAM_BREAKDOWN',
  PERFORMANCE_OVERVIEW: '_PERFORMANCE_OVERVIEW',
  HISTORIC_GRAPH: '_HISTORIC_GRAPH',
  DAYS: '_DAYS',
  MONTHS: '_MONTHS',
  GOAL: '_GOAL',
  ACHIEVEMENT: '_ACHIEVEMENT',
  TARGET: '_TARGET',
  EXPECTED_TARGET: '_EXPECTED_TARGET',
  SHORTFALL: '_SHORTFALL',
  PEOPLE_ACHIEVED: '_PEOPLE_ACHIEVED',
  LAST_UPDATED_ON: '_LAST_UPDATED_ON',
  PERFORMANCE_SNAPSHOT: '_PERFORMANCE_SNAPSHOT',
  FAILED_TO_LOAD_PERFORMANCE_METRICS_DATA:
    '_FAILED_TO_LOAD_PERFORMANCE_METRICS_DATA',
  RANK: '_RANK',
  DESCRIPTION: '_DESCRIPTION',
  POINTS: '_POINTS',
  MY_POINTS: '_MY_POINTS',
  MY_RANKING: '_MY_RANKING',
  TOP_SCORERS: '_TOP_SCORERS',
  DASH: '_DASH',
  BULK_REASSIGN: '_BULK_REASSIGN',
  BULK_REVOKE: '_BULK_REVOKE',
  UPLOAD: '_UPLOAD',
  MISSING_TEMPLATE_DOWNLOAD_LINK: '_MISSING_TEMPLATE_DOWNLOAD_LINK',
  VIEW_PREVIOUS_METRICS: '_VIEW_PREVIOUS_METRICS',
  VIEW_NEXT_METRICS: '_VIEW_NEXT_METRICS',
  MODULE_OR_ACTOR_MISSING: '_MODULE_OR_ACTOR_MISSING',
  ACTIVITY_UPDATED_SUCCESSFULLY: '_ACTIVITY_UPDATED_SUCCESSFULLY',
  PAYMENT_UPDATED_SUCCESSFULLY: '_PAYMENT_UPDATED_SUCCESSFULLY',
  SUSPENDED: '_SUSPENDED',
  WORKFLOW_UPLOADS: '_WORKFLOW_UPLOADS',
  ALLOCATION_TYPE: '_ALLOCATION_TYPE',
  NO_DATA_FOR_THIS_ACTIVITY: '_NO_DATA_FOR_THIS_ACTIVITY',
  INVALID_MULTIMEDIA_ERROR: '_INVALID_MULTIMEDIA_ERROR',
  REQUIRED: '_REQUIRED',
  ENABLE_LOCATION_ACCESS_TO_CHECK_IN: '_ENABLE_LOCATION_ACCESS_TO_CHECK_IN',
  SUPERVISOR_REVIEW: '_SUPERVISOR_REVIEW',
  INITIATE_REVIEW: '_INITIATE_REVIEW',
  UNABLE_TO_LOAD_SUPERVISOR_REVIEWS: '_UNABLE_TO_LOAD_SUPERVISOR_REVIEWS',
  NO_SUPERVISOR_REVIEWS_RECORDED_YET_FOR_THIS_CASE:
    '_NO_SUPERVISOR_REVIEWS_RECORDED_YET_FOR_THIS_CASE',
  VISIBLE_TO_YOU: '_VISIBLE_TO_YOU',
  REPLY: '_REPLY',
  REPLIES: '_REPLIES',
  HIDE_REPLIES: '_HIDE_REPLIES',
  COPY: '_COPY',
  ABC_PDD_TITLE: '_ABC_PDD_TITLE',
  ABC_PDD_SUBTITLE: '_ABC_PDD_SUBTITLE',
  ABC_PDD_PENDING_DOCUMENTS: '_ABC_PDD_PENDING_DOCUMENTS',
  ABC_PDD_CRITICAL_DOCUMENTS: '_ABC_PDD_CRITICAL_DOCUMENTS',
  ABC_PDD_SEARCH_PLACEHOLDER: '_ABC_PDD_SEARCH_PLACEHOLDER',
  ABC_PDD_PAYOUT_HOLD_MESSAGE: '_ABC_PDD_PAYOUT_HOLD_MESSAGE',
  ABC_PDD_NO_RECORDS_FOUND: '_ABC_PDD_NO_RECORDS_FOUND',
  ABC_PDD_NO_MATCHING_RECORDS: '_ABC_PDD_NO_MATCHING_RECORDS',
  ABC_PDD_APPLICATION_NUMBER: '_ABC_PDD_APPLICATION_NUMBER',
  ABC_PDD_CHANNEL_CODE: '_ABC_PDD_CHANNEL_CODE',
  ABC_PDD_PENDING: '_ABC_PDD_PENDING',
  ABC_PDD_CRITICAL: '_ABC_PDD_CRITICAL',
  ABC_PDD_DEFERRED_DATE: '_ABC_PDD_DEFERRED_DATE',
};
